var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container bj-label-colon" },
    [
      _c(
        "BjDivider",
        {
          scopedSlots: _vm._u([
            {
              key: "right",
              fn: function () {
                return [
                  _c("el-button", { on: { click: _vm.handleClose } }, [
                    _vm._v(_vm._s(_vm.$t("backText"))),
                  ]),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm._v(
            _vm._s(
              _vm.$t("BusinessStockSynchronizationDetail.basicInformation")
            ) + " "
          ),
        ]
      ),
      _c(
        "el-form",
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "BusinessStockSynchronizationDetail.adjustCode"
                        ),
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.info.adjustCode) + " ")]
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "BusinessStockSynchronizationDetail.warehouseCode"
                        ),
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.info.warehouseCode) + " ")]
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "BusinessStockSynchronizationDetail.warehouseName"
                        ),
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.info.warehouseName) + " ")]
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 16 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("table.remarkText") } },
                    [_vm._v(" " + _vm._s(_vm.info.remarks) + " ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("BjDivider", [
        _vm._v(
          _vm._s(_vm.$t("BusinessStockSynchronizationDetail.commodityDetails"))
        ),
      ]),
      _c(
        "el-table",
        {
          ref: "multipleTable",
          attrs: {
            data: _vm.info.adjustDetailResVOList,
            stripe: "",
            border: "",
            "header-cell-style": _vm.$rowStyle.DEFAULT,
            "row-key": "BJ_EBC_ID",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              type: "index",
              width: "60",
              align: "center",
              label: _vm.$t("table.countText"),
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "categoryName",
              align: "center",
              label: _vm.$t("goodsPage.categoryName"),
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "skuCode",
              align: "center",
              label: _vm.$t("goodsPage.skuCode"),
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "realityNum",
              align: "center",
              label: _vm.$t("BusinessStockSynchronizationDetail.realityNum"),
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "planNum",
              align: "center",
              label: _vm.$t("BusinessStockSynchronizationDetail.planNum"),
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }